// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import mailboxIcon from "@/assets/icons/aop/mailbox.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MailboxIconProps = Omit<IconProps, "name">;

export function MailboxIcon(props: MailboxIconProps): React.ReactNode {
  return <Icon name={mailboxIcon} {...props} />;
}
